import { Message, MessageBox } from "element-ui";

/**
 * @Description 将时间戳转为日期格式
 * @param {日期} date
 * @param {格式} fmt
 * @author 滕威
 */
export function formatDate(date, fmt) {
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  let o = {
    "M+": date.getMonth() + 1,
    "d+": date.getDate(),
    "h+": date.getHours(),
    "m+": date.getMinutes(),
    "s+": date.getSeconds()
  };
  for (let k in o) {
    if (new RegExp(`(${k})`).test(fmt)) {
      let str = o[k] + "";
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length === 1 ? str : padLeftZero(str)
      );
    }
  }
  return fmt;
}

/**
 * 时间字符串转为时间   固定格式为yyyy-MM-dd HH:mm:ss
 * @param dateStr
 */
export function strToDate(date) {
  // 字符串截取
  date = date.substring(0, 19);
  date = date.replace(/-/g, "/");
  var timestamp = new Date(date).getTime();
  // 根据毫秒数构建 Date 对象
  var dates = new Date(timestamp);
  return dates;
}

/**
 * 将时分秒字符串转为date对象
 * @param date Date对象
 * @param time 时分秒字符串
 */
export function getDate(date, time) {
  // 根据date获取年月日
  var day = formatDate(date, "yyyy-MM-dd");
  // 字符串拼接
  day = day + " " + time;
  var dates = new Date(day);
  return dates;
}

function padLeftZero(str) {
  return ("00" + str).substr(str.length);
}

/**
 * 返回base64编码
 * @params url 图片下载地址
 * @author 滕威
 */
export const fun_GetUrlBase64 = url => {
  return new Promise(resolve => {
    // 创建canvas
    let canvas = document.createElement("canvas");
    let ctx = canvas.getContext("2d");
    // 创建img元素
    let img = new Image();
    // img.crossOrigin = 'Anonymous' //允许跨域
    // 获取img url
    img.src = url;
    // 初始化img属性
    img.onload = function() {
      canvas.height = 300;
      canvas.width = 300;
      ctx.drawImage(img, 0, 0, 300, 300);
      let dataURL = canvas.toDataURL("image/png");
      canvas = null;
      resolve(dataURL);
    };
  });
};

/**
 * 获取两个日期间的所以日期
 */
export const getMonthBetween = (start, end) => {
  var d1 = start,
    d2 = end;
  var result = [];
  var y1 = parseInt(d1.substr(0, 4));
  var m1 = parseInt(d1.substr(5, 2)) - 1;
  var y2 = parseInt(d2.substr(0, 4));
  var m2 = parseInt(d2.substr(5, 2)) - 1;
  do {
    var d = new Date(y1, m1++, 1);
    var y = d.getFullYear();
    var m = d.getMonth() + 1;
    var s = y + (m < 10 ? "0" : "") + m;
    result.push(s);
  } while (d < new Date(y2, m2, 1));
  return result;
};
/**
 * 判断两个时间是否超过天数
 * @params startDate 开始时间
 * @params endDate 结束时间
 * @params day 是否超过天数
 */
export const fun_GetIsMoreThanFiveDaysAgo = (startDate, endDate, day) => {
  const start = new Date(startDate.replace(/-/g, "/")); // 将日期字符串转换为Date对象
  const end = new Date(endDate.replace(/-/g, "/"));
  const diff = Math.abs(start - end); // 计算两个日期之间的差值（毫秒）
  const days = diff / (1000 * 60 * 60 * 24); // 将毫秒转换为天数
  return days > day;
};

/**
 * 下载文件公共方法
 * @params res 下载文件接口返回的流
 * @params pictureName 文件名称
 * @author 滕威
 */
export const fun_DownloadFile = (res, pictureName) => {
  const data = new Blob([res.data]);
  const reader = new FileReader();
  // 读取文件
  reader.readAsText(data);
  // 触发onload事件
  reader.onload = () => {
    // json格式数据转换成对象
    if (reader.result.indexOf("result") > -1) {
      const result = JSON.parse(reader.result);
      if (result.result == false) {
        Message.error(result.msg);
      }
    } else {
      if (window.navigator.msSaveBlob) {
        // IE以及IE内核的浏览器
        // window.navigator.msSaveBlob(data, pictureName);
        window.navigator.msSaveOrOpenBlob(data, pictureName);
      } else {
        let link = document.createElement("a");
        // 创建URL对象
        link.href = URL.createObjectURL(data);
        // 放入body元素中
        document.body.appendChild(link);
        // 获取图片名字
        link.download = pictureName;
        // 执行a标签点击事件
        link.click();
        // 释放URL对象
        URL.revokeObjectURL(link.href);
        // 在body中移除元素
        document.body.removeChild(link);
      }
    }
  };
};

/**
 * 下载文件公共方法（无错误判断）
 * @params res 下载文件接口返回的流
 * @params pictureName 文件名称
 * @author cys
 */
export const fun_DownloadFileNot = (res, pictureName) => {
  const data = new Blob([res.data]);
  const reader = new FileReader();
  // 读取文件
  reader.readAsText(data);
  // 触发onload事件
  reader.onload = () => {
    if (window.navigator.msSaveBlob) {
      // IE以及IE内核的浏览器
      // window.navigator.msSaveBlob(data, pictureName);
      window.navigator.msSaveOrOpenBlob(data, pictureName);
    } else {
      let link = document.createElement("a");
      // 创建URL对象
      link.href = URL.createObjectURL(data);
      // 放入body元素中
      document.body.appendChild(link);
      // 获取图片名字
      link.download = pictureName;
      // 执行a标签点击事件
      link.click();
      // 释放URL对象
      URL.revokeObjectURL(link.href);
      // 在body中移除元素
      document.body.removeChild(link);
    }
  };
};

/**
 * alert提示消息公共方法
 * @params title 提示内容
 * @author 滕威
 */
export const fun_CommonAlert = (title, msgType) => {
  MessageBox.alert(title, "提示", {
    type: msgType ? msgType : "warning"
  }).then(() => {});
};

/**
 * 数组属性值拆分用,隔开公共方法
 * @description 主要用于批量删除时组合id
 * @params parameter 数组参数
 * @params state 判断是否可以修改删除的字段
 * @author 滕威
 */
export const fun_GetKeys = rows => {
  if (rows.length > 1) {
    let keys = [];
    rows.map(e => {
      keys = [...keys, e.id];
    });
    return keys.join(",");
  } else {
    return rows[0].id;
  }
};

/**
 * @description 核验状态转译
 * @param 核验状态value
 * @author 滕威
 */
export const fun_CheckState = checkState => {
  switch (checkState) {
    case "0":
      return "核验中";
    case "1":
      return "核验通过";
    case "2":
      return "核验不通过";
    case "3":
      return "待提交";
  }
};
/**
 * @description 核验状态转译
 * @param 核验状态value
 * @author 滕威
 */
export const fun_State = checkState => {
  switch (checkState) {
    case "tj":
      return "提交";
    case "th":
      return "退回";
    case "bc":
      return "保存";
    case "tg":
      return "通过";
    case "qr":
      return "确认";
    case "sl":
      return "已受理";
    case "wt":
      return "已委托";
    case "fb":
      return "已发布";
    case "xz":
      return "已下载";
  }
};
/**
 * @description 用户状态转译
 * @param 用户状态value
 * @author 滕威
 */
export const fun_UserState = userState => {
  switch (userState) {
    case "0":
      return "废止";
    case "1":
      return "启用";
  }
};

/**
 * @description 角色类型转译
 * @param 角色类型value
 * @author 滕威
 */
export const fun_UserRole = userRole => {
  switch (userRole) {
    case "204b4c78-9a74-449d-aeb2-3b287c4398d1":
      return "工作人员";
    case "6c4c0dee-0490-4e8b-91b9-ea01063eabc4":
      return "系统管理员";
  }
};

/**
 * @description 是否固定角色转译
 * @param 是否固定角色value
 * @author 滕威
 */
export const fun_FixedAuthority = fixedAuthority => {
  switch (fixedAuthority) {
    case "0":
      return "否";
    case "1":
      return "是";
  }
};

/**
 * @description 包类别转译
 * @param 是否固定角色value
 * @author 滕威
 */
export const fun_Categories = categories => {
  switch (categories) {
    case "hw":
      return "货物";
    case "fw":
      return "服务";
    case "gc":
      return "工程";
  }
};

/**
 * @description 打分方法转译
 * @param 是否固定角色value
 * @author 滕威
 */
export const fun_Mark = categories => {
  switch (categories) {
    case 1:
      return "自动算分";
    case 2:
      return "客观分";
    case 3:
      return "专家打分";
    case 4:
      return "合格制";
    case 5:
      return "其他打分";
    case 0:
      return "无";
  }
};

/**
 * @description 是否资格预审
 * @param 是否资格预审value
 * @author 滕威
 */
export const fun_PrequalificationType = prequalificationType => {
  switch (prequalificationType) {
    case "1":
      return "资格预审";
    case "2":
      return "项目评审";
  }
};

/**
 * @description 判断是否为空
 * @param 参数
 * @author 滕威
 */
export const fun_isBlank = data => {
  if (data == "" || data == null || data == undefined) {
    return true;
  }
  return false;
};

/**
 * 判断数据类型
 * @param o
 * @returns {string}
 */
export const getClass = o => {
  return Object.prototype.toString.call(o).slice(8, -1);
};
/**
 * 深拷贝
 * @param obj
 * @returns {{}|*}
 */
export const deepCopy = obj => {
  var result,
    oClass = getClass(obj);
  if (oClass == "Object") result = {};
  //判断传入的如果是对象，继续遍历
  else if (oClass == "Array") result = [];
  //判断传入的如果是数组，继续遍历
  else return obj; //如果是基本数据类型就直接返回
  for (var i in obj) {
    var copy = obj[i];
    if (getClass(copy) == "Object") result[i] = deepCopy(copy);
    //递归方法 ，如果对象继续变量obj[i],下一级还是对象，就obj[i][i]
    else if (getClass(copy) == "Array") result[i] = deepCopy(copy);
    //递归方法 ，如果对象继续数组obj[i],下一级还是数组，就obj[i][i]
    else result[i] = copy; //基本数据类型则赋值给属性
  }

  return result;
};
